import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	dashboard__templates: 'mw/dashboard/templates',
	dashboard__filter: 'mw/dashboard/filter',
	dashboard__appealkpi: 'mw/dashboard/appealkpi',
	dashboard__filter__interactappealmap: 'mw/dashboard/filter/interactappealmap',
	dashboard__filter__appealtoptenq: 'mw/dashboard/filter/appealtoptenq',
	dashboard__filter__appealcount: 'mw/dashboard/filter/appealcount',
	dashboard__filter__apealstatusesbydest: 'mw/dashboard/filter/apealstatusesbydest',
	dashboard__filter__apealstatusesbytype: 'mw/dashboard/filter/apealstatusesbytype',
	dashboard__filter__appealtoptendest: 'mw/dashboard/filter/appealtoptendest',
	dashboard__filter__appealtoptenoper: 'mw/dashboard/filter/appealtoptenoper',
};

export const dashboardApi = createApi({
	reducerPath: 'mw/dashboardApi',

	endpoints: (builder) => ({
		dashboardTemplates: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/dashboard/templates?${qs.stringify(body)}`,
			}),
			providesTags: [tags.dashboard__templates],
		}),
		dashboardFilter: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/dashboard/filter?${qs.stringify(body)}`,
			}),
			providesTags: [tags.dashboard__filter],
		}),
		dashboardAppealkpi: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/appealkpi',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__appealkpi],
		}),
		dashboardFilterInteractappealmap: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/interactappealmap',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__interactappealmap],
		}),
		dashboardFilterAppealtoptenq: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/appealtoptenq',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__appealtoptenq],
		}),
		dashboardFilterAppealcount: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/appealcount',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__appealcount],
		}),
		dashboardFilterApealstatusesbydest: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/apealstatusesbydest',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__apealstatusesbydest],
		}),
		dashboardFilterApealstatusesbytype: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/apealstatusesbytype',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__apealstatusesbytype],
		}),
		dashboardFilterAppealtoptendest: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/appealtoptendest',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__apealstatusesbytype],
		}),
		dashboardFilterAppealtoptenoper: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/dashboard/filter/appealtoptenoper',
				body,
				jsonType: true,
			}),
			providesTags: [tags.dashboard__filter__appealtoptenoper],
		}),
	}),
});

export const {
	dashboardTemplates,
	dashboardFilter,
	dashboardAppealkpi,
	dashboardFilterInteractappealmap,
	dashboardFilterAppealtoptenq,
	dashboardFilterAppealcount,
	dashboardFilterApealstatusesbydest,
	dashboardFilterApealstatusesbytype,
	dashboardFilterAppealtoptendest,
	dashboardFilterAppealtoptenoper,
} = dashboardApi.endpoints;

export default dashboardApi;
